import React from "react";

class AccessibilityComponent extends React.Component {
    render() {
        return (
            <div>
                <p className="bold">Accessibility Statement</p>
                <p className="bold">Commitment to Digital Accessibility</p>
                <p>The Division of Legislative Automated Systems (DLAS) is committed to ensuring equitable
                    access to information, services, and programs for all members of the public. We strive to
                    provide digital content and technology that is accessible to individuals with
                    disabilities, including those who use assistive technologies. We are working to conform with the
                    Web Content Accessibility Guidelines (WCAG) 2.1 Level AA, which is the technical
                    standard adopted by the U.S. Department of Justice (DOJ) for Title II entities. </p>
                <p>This commitment applies to:</p>
                <ul >
                    <li>Optimizing our public website for compatibility with assistive technologies (such as
                        screen readers).</li>
                    <li>Ensuring digital documents posted after the compliance deadline have better
                        structural navigation and readability.</li>
                    <li>Designating legacy digital documents as "archived".</li>
                    <li>Third-party integrations to the extent possible.</li>
                </ul>
                <p className="bold">Third-Party Content</p>
                <p>Where third-party platforms or software are integrated, DLAS works to ensure accessibility but may not control all
                    components of those systems. DLAS does not have control over content or documents housed on third-party websites
                    that we may link out to and cannot guarantee the accessibility of third-party content
                    and documents. </p>
                <p className="bold">Alternative Access and Accommodations</p>
                <p>While DLAS strives for compliance, certain non-archived content or complex data
                    visualizations may have limitations. If you encounter any accessibility barriers or need to
                    request an archived report or other document created by DLAS in an alternative format, please contact us. We
                    will make every reasonable effort to provide the requested information in an accessible
                    format.</p>
                <p>
                    Division of Legislative Automated Systems<br />
                    Email: <a href="mailto:webmaster@dlas.virginia.gov">webmaster@dlas.virginia.gov</a><br />
                    Phone: (804) 786-1895 <br />
                    Mailing address: Old City Hall, 1001 East Broad Street, Suite 210, Richmond, Virginia 23219</p>
                <p>To assist us in addressing the issue, please include:</p>
                <ul>
                    <li>URL or location of the content</li>
                    <li>Description of the issue encountered</li>
                    <li>Assistive technology or device used (if applicable)</li>
                </ul>
                <p>We aim to respond to requests for accommodation, alternative access, or accessibility assistance within seven business days.</p>
                <p>Last updated: June 10, 2026</p>
            </div>
        )
    }
}

export default AccessibilityComponent;
